import React, {useState} from 'react';
import { useLocation } from 'react-router-dom';
import FilterRecommendationsButton from './components/filterRecommendationsButton';
import FeedbackSettingsButton from './components/feedbackSettingsButton';
import RecommendationFeedbackButtons from './components/recommendationFeedbackButtons';
import RecommendationsGrid from './components/recommendationsGrid';

const RecommendationsTab = () => {
  const location = useLocation();
  const [filteredRecommendations, setFilteredRecommendations] = useState(false);
  const [gridLoaded, setGridLoaded] = useState(false);
  const [recommendationCount, setRecommendationCount] = useState(0);
  const [totalRecommendationCount, setTotalRecommendationCount] = useState(0);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);


  return (
    <div className={'recommendationsTab'}>
      <FilterRecommendationsButton
        gridLoaded={gridLoaded}
        recommendationCount={recommendationCount}
        totalRecommendationCount={totalRecommendationCount}
        feedbackButtons={selectedRecommendation && <RecommendationFeedbackButtons recommendation={selectedRecommendation} />}
        feedbackSettings={<FeedbackSettingsButton />}
      />
      <RecommendationsGrid
        setGridLoaded={setGridLoaded}
        filteredRecommendations={filteredRecommendations}
        setRecommendationCount={setRecommendationCount}
        setTotalRecommendationCount={setTotalRecommendationCount}
        onSelectRecommendation={setSelectedRecommendation}
        selectCode={location.state?.selectIssueCode}
        selectToken={location.key}
      />
    </div>
  );
}

export default RecommendationsTab;
